export default "__VITE_ASSET__DfnD_pOj__"